/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Add_LinkInputs */



/**
* | output |
* | --- |
* | "Add your link" |
*
* @param {Community_Add_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_add_link = /** @type {((inputs?: Community_Add_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Add_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter votre lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir tu enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar seu link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi il tuo link")
	return /** @type {LocalizedString} */ ("Add your link")
});